import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  actions: {
    create({ commit, dispatch }, model) {
      return ajax.post("Sales/api/productQuery/", model);
    },
    productQuery({ commit, dispatch }, name) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Sales/api/productQuery/" + name)
          .then(r => {
            commit("setList", r.data);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    },
    createCharge({ commit, dispatch }, model) {
      return ajax.post("Sales/api/ChargeTransactions", model);
    },
    createDischarge({ commit, dispatch }, model) {
      return ajax.post("Sales/api/DischargeTransactions", model);
    },
    
  }
};
